import { env } from '@/env';

/**
 * Di chi sono i dati su QUESTA build — una costante di compilazione, non uno stato.
 *
 * 🔑 Esiste perche' la stessa domanda si e' gia' posta due volte in due file diversi
 * (`hooks/useQlashUser.ts` per l'identita', `hooks/useEngagementEngine.ts` per i tornei) e
 * una regola scritta due volte e' una regola che diverge. Qui ha una sede sola.
 *
 * ⚠️ **E' una COSTANTE, ed e' il punto.** La versione sbagliata di questa domanda — quella
 * che #126 aveva lasciato in giro — era «ho gia' il dato?», cioe' uno **stato** che cambia
 * nel tempo: nella finestra fra il montaggio e la risposta di Limulo quello stato e' ancora
 * vuoto, lo skip non scatta, e parte Laravel. Misurato da or45 il 2026-09-05: **12
 * `exchange-token` 503 per giro** su rotte `/limulo/*` pure.
 * 📌 *Una corsa non si vince mettendo la condizione giusta piu' presto: si vince togliendo
 * il secondo concorrente.*
 *
 * ⚠️ Non e' un ripiego e non deve diventarlo: i due backend rispondono con **due spazi di id
 * diversi** (numerico Laravel contro ObjectId Limulo). Una build sceglie una volta.
 * Il perche' esteso in `lib/limulo/identity.ts`.
 */
export const laravelOwnsData = (): boolean => !env.featureLimuloEnabled;
